import {
  BUDGET_ESTIMATED,
  ECA_PERMISSION_CODES_CONSTANTS,
  EVIDENCE_SOURCE_MANAGEMENT,
} from '../../../../constants/constants';
import {Permission} from '../../../../types/permission-group/permission';
import {ClientProject} from '../../../../types/project-type/projectDetailsType';
import {Workspace} from '../models';

export const checkBudgetConsumptionEnabledByProjectLevel = (
  clientProjects: ClientProject[],
  clientHCProjects: ClientProject[],
  projectId?: string
) =>
  !(
    (clientProjects.find(
      (value) => value.projectId.toLowerCase() === projectId?.toLowerCase()
    )?.budgetConsumptionEnabled ||
      clientHCProjects.find(
        (value) => value.projectId.toLowerCase() === projectId?.toLowerCase()
      )?.budgetConsumptionEnabled) ??
    false
  );

export const checkEcaEnabledByProjectLevel = (
  clientProjects: ClientProject[],
  clientHCProjects: ClientProject[],
  projectId?: string
) =>
  (clientProjects.find(
    (value) => value.projectId.toLowerCase() === projectId?.toLowerCase()
  )?.ecaEnabled ||
    clientHCProjects.find(
      (value) => value.projectId.toLowerCase() === projectId?.toLowerCase()
    )?.ecaEnabled) ??
  false;

export const getPermissionDetail = (
  type:
    | BUDGET_ESTIMATED
    | EVIDENCE_SOURCE_MANAGEMENT
    | ECA_PERMISSION_CODES_CONSTANTS,
  permissions?: Permission[]
) => {
  if (!permissions?.length) return undefined;
  switch (type) {
    // Estimated Budget Consumption
    case BUDGET_ESTIMATED.REPORT_BUDGET_CONSUMPTION:
    case BUDGET_ESTIMATED.REPORT_BUDGET_ALERT:
      return permissions.find(
        (permission) => permission.permissionCode === type
      );

    // Evidence Source Management
    case EVIDENCE_SOURCE_MANAGEMENT.STAGING_AREA_ACCESS:
    case EVIDENCE_SOURCE_MANAGEMENT.EVIDENCE_SOURCE_UPLOAD_ACCESS:
    case EVIDENCE_SOURCE_MANAGEMENT.INITIATE_PROCESSING_ACCESS:
      return permissions.find(
        (permission) => permission.permissionCode === type
      );

    // ECI Permissions
    case ECA_PERMISSION_CODES_CONSTANTS.ECA_NON_ADMIN_ONEOF:
    case ECA_PERMISSION_CODES_CONSTANTS.ECA_ADMIN_ONEOF:
    case ECA_PERMISSION_CODES_CONSTANTS.ECA_NONE:
    case ECA_PERMISSION_CODES_CONSTANTS.ECA_CREATE_DOCUMENT:
    case ECA_PERMISSION_CODES_CONSTANTS.ECA:
      return permissions.find(
        (permission) => permission.permissionCode === type
      );

    default: {
      const _exhaustiveCheck: unknown = type;
      console.log('Unhandled permission type:', _exhaustiveCheck);
      return undefined;
    }
  }
};

export const getPermissionDetailById = (
  permissionId?: string,
  permissions?: Permission[]
) => {
  return permissions?.find(
    (permission) =>
      permission?.permissionId?.toLowerCase() === permissionId?.toLowerCase()
  );
};

export const getAvailablePermissions = (groupPermissions?: Permission[]) => {
  const hasNone = groupPermissions?.some(
    (permission) =>
      permission.permissionCode === ECA_PERMISSION_CODES_CONSTANTS.ECA_NONE
  );
  if (hasNone === true) return;

  const getECAPermissions =
    groupPermissions?.filter(
      (permission) => permission.type === ECA_PERMISSION_CODES_CONSTANTS.ECA
    ) ?? [];

  return getECAPermissions;
};

export const getWorkspacesWithDisplayValue = (
  workspaces: Workspace[] | undefined
) =>
  workspaces?.map((workspace: Workspace) => ({
    ...workspace,
    workspaceDisplay: `${workspace.workspaceCode} - ${workspace.workspaceName}`,
  }));
